import { render, staticRenderFns } from "./Natalchart.vue?vue&type=template&id=a4d46210&lang=pug&"
import script from "./Natalchart.vue?vue&type=script&lang=js&"
export * from "./Natalchart.vue?vue&type=script&lang=js&"
import style0 from "./Natalchart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports